import React from 'react';
import { connect } from 'react-redux';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';


import {STAR_TRAVELER_CODE, FIDELTOUR_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import StandarPoliciesChecks from "./Standar/PoliciesChecks";
import STPoliciesChecks from "./StarTraveler/PoliciesChecks";
import FidelTourPoliciesChecks from './FidelTour/PoliciesChecks';




//const iscorporate = store.getIn(['customer', 'corporate', 'tipo_perfil'], false) === '1'

const LoyaltyPoliciesChecks = class LoyaltyPoliciesChecks extends React.Component {
  static displayName = 'LoyaltyPoliciesChecks';
  render() {
    const {config } = this.props;
    const {loyaltyUser, loyaltySelected, loyaltyType } = config;
    
    if(STAR_TRAVELER_CODE === loyaltyType && loyaltySelected && !loyaltyUser) {
      return (<STPoliciesChecks {...this.props}/>);
    }
    else if (FIDELTOUR_CODE === loyaltyType && loyaltySelected) {
      return (
        <>
          {!loyaltyUser ? <FidelTourPoliciesChecks {...this.props}/> : <StandarPoliciesChecks {...this.props}/> }
        </>
      );
    }
    else {
      return (<StandarPoliciesChecks {...this.props}/>);
      // return null;
    }
  };
};



const mapStateToProps = (store) => {
  const reservation = store.getIn(['customer', 'reservation']);
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const loyaltyType = store.getIn(["customer", "loyalty", "data", "loyalty", "code"], null);
  
  const isNotFinallyConfirmed = !(
    reservation.get('status', false) === 'confirmed' &&
    !(
      (['op', 'amazon_pay'].includes(reservation.getIn(['payment', 'payform_code'], false))) &&
      reservation.getIn(['payment', 'state'], false) === 'pending'
    )
  );


  const roomRatesSelected = store.getIn(['customer', 'reservation_request']);
  const loyaltyRoomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'loyalty_query_params']),
    'response'
  ], false);
 
  const reservationHasNoLoyalty = reservation.size > 0 && !reservation.get('loyalty');

  let loyaltySelected =
    !!loyaltyRoomsAvail &&
    !reservationHasNoLoyalty &&
    roomRatesSelected.get('loyalty', false);

  let loyaltyUser = store.getIn(['customer', 'loyalty','user',"user_id"], null) && store.getIn(['customer', 'loyalty','user'], null);

  return {
    loyaltyUser: loyaltyUser,
    loyaltySelected: loyaltySelected,
    loyaltyType,
    isCorporate : store.getIn(['customer', 'corporate', 'tipo_perfil'], false) === '1',
    reservation: reservation.size > 0 && isNotFinallyConfirmed ? reservation : undefined,
    isLoyaltyPrice: !!reservation.getIn(['loyalty'], ((FIDELTOUR_CODE === loyaltyType || !loyaltySelected)))
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(mapStateToProps),
  //withThemeJSS(),
  PropertyManager([
    "classes", "group", "penalties", "requiredPrepaymentText", "loyaltyType", "loyaltyUser", "loyaltySelected", "profileType", "reservation","hotel", "isCorporate"
  ])
)(LoyaltyPoliciesChecks);